<template>
  <v-container>
    <v-layout wrap justify-center>
      <v-flex md3 xs12 class="mt-3 mr-2" v-for="(item, i) in items" :key="i">
        <v-card color="primary" dark class="pa-3" :to="item.to" height="200">
          <v-layout justify-center>
            <v-icon class="mt-12">{{ item.icon }}</v-icon>
          </v-layout>
          <p class="text-center mt-2">{{ item.text }}</p>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          icon: 'mdi-library',
          text: 'Atividades',

          to: '/atividades'
        },
        {
          icon: 'mdi-bullhorn',
          text: 'Comunicados',

          to: '/comunicados'
        },
        {
          icon: 'mdi-calendar',
          text: 'Eventos',

          to: '/eventos'
        },
        {
          icon: 'mdi-camera',
          text: 'Galerias',

          to: '/galerias'
        },
        {
          icon: 'mdi-food',
          text: 'Refeições',
          to: '/refeicoes'
        },
        {
          icon: 'mdi-forum',
          text: 'Mensagens',
          to: '/mensagens'
        }
      ]
    }
  }
}
</script>
